"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsersNew(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: props.fill,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.617 6.872a3.326 3.326 0 013.32-3.334 3.326 3.326 0 013.318 3.334 3.326 3.326 0 01-3.319 3.333 3.326 3.326 0 01-3.319-3.333zM8.937 2c-2.68 0-4.852 2.181-4.852 4.872 0 2.69 2.172 4.872 4.851 4.872 2.68 0 4.851-2.182 4.851-4.872S11.615 2 8.937 2zM4.85 14.307a4.84 4.84 0 00-3.43 1.427A4.882 4.882 0 000 19.18v2.052c0 .424.343.769.766.769a.768.768 0 00.766-.77v-2.05c0-.885.35-1.733.972-2.358a3.312 3.312 0 012.347-.976h8.17c.88 0 1.725.351 2.347.976a3.34 3.34 0 01.972 2.357v2.052c0 .424.343.769.766.769a.768.768 0 00.766-.77v-2.05a4.883 4.883 0 00-1.42-3.446 4.841 4.841 0 00-3.43-1.427h-8.17zm14.578.711a.766.766 0 01.933-.553 4.85 4.85 0 012.62 1.733A4.885 4.885 0 0124 19.178v2.053c0 .425-.343.769-.766.769a.768.768 0 01-.766-.77v-2.05c0-.738-.245-1.456-.696-2.04-.45-.583-1.081-1-1.793-1.185a.77.77 0 01-.55-.937zM16.275 2.157a.77.77 0 00-.38 1.49c.714.184 1.347.6 1.799 1.185a3.343 3.343 0 010 4.088 3.318 3.318 0 01-1.799 1.185.77.77 0 00.38 1.49 4.85 4.85 0 002.629-1.732 4.885 4.885 0 000-5.974 4.85 4.85 0 00-2.629-1.732z",
    fill: "inherit"
  }));
}

var _default = SvgUsersNew;
exports.default = _default;